import { getBancoGeneralAll, newBancoGeneral, deleteBancoGeneral, updateBancoGeneral } from "../services/bancoServices"
const dataInicial = {
    bancosMain: [],
    bancoMain: {},
    exito: 0,
    editar: false,
}
const GET_BANCO_MAIN_ALL_ACTION = "GET_BANCO_MAIN_ALL_ACTION"
const GET_BANCO_MAIN_DETALLE_ACTION = "GET_BANCO_MAIN_DETALLE_ACTION"
const DELETE_BANCO_MAIN_ACTION = "DELETE_BANCO_MAIN_ACTION"
const UPDATE_BANCO_MAIN_ACTION = "UPDATE_BANCO_MAIN_ACTION"
const NEW_BANCO_MAIN_ACTION = "NEW_BANCO_MAIN_ACTION"

export default function bancoMainReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_BANCO_MAIN_ALL_ACTION:
            return { ...state, bancosMain: action.payload.bancosMain }
        case GET_BANCO_MAIN_DETALLE_ACTION:
            return { ...state, bancoMain: action.payload.bancoMain, editar: action.payload.editar }
        case DELETE_BANCO_MAIN_ACTION:
            return { ...state, exito: action.payload.exito }
        case UPDATE_BANCO_MAIN_ACTION:
            return { ...state, exito: action.payload.exito }
        case NEW_BANCO_MAIN_ACTION:
            return { ...state, exito: action.payload.exito }
        default:
            return state;
    }
}
export const targetBancoAction = ({ banco, editar }) => (dispatch) => {
    dispatch({
        type: GET_BANCO_MAIN_DETALLE_ACTION,
        payload: {
            bancoMain: banco,
            editar
        },
    })
}
export const obtenerBancosAllAction = () => async (dispatch) => {
    return await getBancoGeneralAll().then(Response => {
        dispatch({
            type: GET_BANCO_MAIN_ALL_ACTION,
            payload: {
                bancosMain: Response,
            },
        });
        return Response
    }).catch(Error => {
        return []
    })
}
export const nuevoBancoAction = ({ Nombre, TasaGeneral }) => async (dispatch) => {
    return await newBancoGeneral({ Nombre, TasaGeneral }).then(Response => {
        dispatch({
            type: NEW_BANCO_MAIN_ACTION,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const actulizaBancoAction = ({ idBanco, Nombre, TasaGeneral }) => async (dispatch) => {
    return await updateBancoGeneral({ IdBancoGeneral: idBanco, Nombre, TasaGeneral }).then(Response => {
        dispatch({
            type: UPDATE_BANCO_MAIN_ACTION,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const eliminarBancoAction = ({ idBanco }) => async (dispatch) => {
    return await deleteBancoGeneral({ IdBancoGeneral: idBanco }).then(Response => {
        dispatch({
            type: DELETE_BANCO_MAIN_ACTION,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}